export default {
      id: "small-right-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-right",
      toString: function () {
        return this.url;
      }
    }